import { apiRequest } from './index';
import { getFullName } from '../helpers/functions/employee';

export const fetchEmployeeRequest = (id, success = (result = []) => { }, failure = (error) => { }) => {
    apiRequest('/employees/' + id, {}, success, failure);
}

export const fetchEmployeeLeaveBalanceRequest = (
    id,
    year,
    success = (result = {}) => {},
    failure = (error) => {},
    asOf = null
) => {
    const asOfQuery = asOf ? `&asOf=${asOf}` : "";
    apiRequest(
        `/employees/${id}/leave-balances?year=${year}${asOfQuery}`,
        {},
        success,
        failure
    );
}

export const fetchEmployeesRequest = ( filters, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(`/employees?page=${filters.page}&limit=${filters.limit}&term=${filters.term}&department=${filters.department}&position=${filters.position}&status=${filters.status}`, {}, success, failure);
}

export const fetchPendingEmployeesRequest = (success = (result = []) => { }, failure = (error) => { }) => {
    apiRequest('/employees/pending', {}, success, failure);
}

export const countPendingEmployeesRequest = (success = (result = []) => { }, failure = (error) => { }) => {
    apiRequest('/employees/pending/count', {}, success, failure);
}

export const createEmployeeRequest = (data, success = (result = []) => { }, failure = (error) => { }) => {
    apiRequest(
        '/employees',
        {
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editEmployeeRequest = (id, data, success = (result = []) => { }, failure = (error) => { }) => {
    return apiRequest(
        '/employees/' + id,
        {
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const handleEmployeeApprovalRequest = (id, data, success = (result = []) => { }, failure = (error) => { }) => {
    apiRequest(
        '/employees/approval/' + id,
        {
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

const buildEmployeeOptions = employee => ({
    value: employee ? employee._id : '',
    label: employee ? getFullName(employee) : '',
    data: employee
});

export const employeeSelectOptionRequest = (filters = {}, success = (result = []) => {}, failure = (error) => {}) => {
    const { term = "" } = filters
    fetch(`${process.env.REACT_APP_API_ENDPOINT}/employees?term=${term}`)
        .then(response => response.json())
        .then(({employees}) => {
            const selectOptions = [];
            employees.forEach((item) => {
                const option = buildEmployeeOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error);
        });
}

export const deleteEmployeeRequest = (id, success = (result = []) => { }, failure = (error) => { }) => {
    apiRequest(
        '/employees/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
